module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-search/eventsearch-postedclaim-gladjustment/eventsearch-postedclaim-gladjustment.component.css
// module id = ./src/app/components/event-search/eventsearch-postedclaim-gladjustment/eventsearch-postedclaim-gladjustment.component.css
// module chunks = main